export default __webpack_public_path__ + "static/media/k5.ad80edec.jpg";